import React from 'react';
import TableGrid from './TableGrid';
import TableGridHeader from './TableGridHeader';
import Scroll from 'react-scroll';
//import {Buttons} from './Buttons';

const TableGridContainer = (props) => {
    return (
        <Scroll.Element name={props.name} id={props.name}>
            {/*<Buttons/>*/}
            <div className="tableGrid-container">
                <TableGridHeader title={props.title}/>
                <TableGrid data={props.data}   />
            </div>

        </Scroll.Element>
    );
};

export default TableGridContainer;



// WEBPACK FOOTER //
// ./src/Components/TableGridContainer.js